
let isSuccessRoutePage=false

export const setSuccessRoutePage=(status)=>{
    isSuccessRoutePage=status
}

export const getSuccessRoutePage=()=>isSuccessRoutePage
